import React from "react";

const Title = ({ pageTitle }) => {
  return <h2>{pageTitle}</h2>;
};

export default Title;
